import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { API } from "@/lib/api";

const ERROR_MESSAGES = {
  ms_login_failed: "Microsoft sign-in failed. Please try again.",
  ms_login_expired: "That sign-in attempt expired. Please try again.",
  ms_not_configured: "Microsoft sign-in isn't set up yet. Contact your admin.",
};

const MicrosoftLogo = () => (
  <svg width="16" height="16" viewBox="0 0 21 21" aria-hidden="true">
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </svg>
);

export default function Login() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");
  const [redirecting, setRedirecting] = useState(false);

  const continueWithMicrosoft = () => {
    setRedirecting(true);
    window.location.href = `${API}/auth/ms/login`;
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4" data-testid="login-page">
      <div className="w-full max-w-sm card-flat p-8 text-center">
        <div className="flex items-center justify-center gap-2 mb-1">
          <div className="w-9 h-9 flex items-center justify-center" style={{
            borderRadius: "7px",
            background: "linear-gradient(145deg, #7dd8fb 0%, #38bdf8 45%, #0369a1 100%)",
            boxShadow: "inset 0 1px 1px rgba(255,255,255,0.55), inset 0 -1px 2px rgba(0,0,0,0.3), 0 1px 3px rgba(0,0,0,0.35)",
          }}>
            <span className="font-display font-black text-sm text-white">PH</span>
          </div>
          <span className="font-display font-extrabold text-lg">Project Hub</span>
        </div>
        <p className="label-caps mb-6 justify-center">Enterprise Edition</p>

        {error && (
          <div data-testid="login-error" className="text-xs text-destructive font-medium mb-4">
            {ERROR_MESSAGES[error] || "Something went wrong. Please try again."}
          </div>
        )}

        <button
          data-testid="ms-login-btn"
          onClick={continueWithMicrosoft}
          disabled={redirecting}
          className="btn-navy w-full flex items-center justify-center gap-2"
        >
          <MicrosoftLogo />
          {redirecting ? "Redirecting to Microsoft..." : "Continue with Microsoft"}
        </button>
        <p className="text-xs text-muted-foreground mt-6">Sign in with your organization's Microsoft 365 account.</p>
      </div>
      <div className="text-[10px] font-mono text-muted-foreground mt-4" data-testid="login-company-footer">© 2026 Radish Technologies</div>
    </div>
  );
}
